// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class ProjectsProjections  {
    _originalTypeClassName = "Loom.BO.ProjectsProjections";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
ProjectsProjections.translate = translateService;
}
this.ProjectOverviews = [];
this.Id = null;
this.From = null;
this.To = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
From:any;
To:any;
Organisation:any;
ProjectOverviews:any;
static setOrganisation = ($this, value) => {
var oldValue = $this.Organisation;
$this.Organisation = value;
if (value != null) {
}
}
static setProjectOverviews = ($this, items) => {
                if (items == null) items = [];
                if ($this.ProjectOverviews == null) $this.ProjectOverviews = [];

                const copyItems = Common.cloneObject(items);

                while ($this.ProjectOverviews.length > 0) {
                    Domain.ProjectsProjections.removeProjectOverviews($this, $this.ProjectOverviews[0]);
                }

                Domain.ProjectsProjections.addManyProjectOverviews($this, copyItems);
            }
static addManyProjectOverviews = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.ProjectsProjections.addProjectOverviews($this, items[i]);
                }
            }
static addProjectOverviews = ($this, item) => {
                if ($this.ProjectOverviews == null) $this.ProjectOverviews = [];
                if (item == null || $this.ProjectOverviews.indexOf(item) > -1) return;
                $this.ProjectOverviews.push(item);
}
static addRangeProjectOverviews = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.ProjectsProjections.addProjectOverviews($this, item));
            }
static removeProjectOverviews = ($this, item) => {
                if ($this == null || $this.ProjectOverviews == null || $this.ProjectOverviews.indexOf(item) === -1) return;
                var _index = $this.ProjectOverviews.indexOf(item);
                $this.ProjectOverviews.splice(_index, 1);
}
static clearProjectOverviews = ($this) => { $this.ProjectOverviews = null; }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}